import moment from 'moment';
import Select from 'react-select';
import './BranchDropdown.scss';

const currentYear = moment().year();

export const MONTH_OPTIONS = moment.months().map((month, index) => ({
    label: `${month} ${currentYear}`,
    value: index,
}));

const MonthDropdown = ({ value, onChange }) => {
    return (
        <div className="branch-dropdown">
            <Select
                options={MONTH_OPTIONS}
                value={value}
                onChange={onChange}
                isSearchable={false}
                isClearable={false}
            />
        </div>
    );
};

export default MonthDropdown;
